import React from "react";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import UsageAnalyticsComp from "../../../components/usersettings/usageanalyticscomp";

export default function UsageAnalytics() {
  return (
    <>
      <UserProfileLayout>
        <div className="w-full bg-white rounded-2xl border border-primary50 justify-start gap-4 flex p-8 mb-4">
          <UsageAnalyticsComp />
        </div>
      </UserProfileLayout>
    </>
  );
}
